// services/config.js
const API_BASE_URL = 'https://node.sriramsias.com/';
export const SITE_KEY = '6Le169sqAAAAAIyl3eU1u6xSQPvu4kPfgkENv5aR'
export const SECRET_KEY = '6Le169sqAAAAAMfnky5ofAKnWzfZGo12Q9W0G20P'

export default API_BASE_URL;
